// extracted by mini-css-extract-plugin
export default {"background":"wXXHX8","container":"UZJLP7","responsiveCards":"WkyYZe","topPadding":"J2nGYF","contentPadding":"rCxgkE"};